export default class UtmCoordinate {
    public easting: number = 0;
    public northing: number = 0;
}
